// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"4de49ffd","99":"c1e0d414","283":"918b384c","353":"ca0dcb9b","357":"7231f5f2","516":"7c9d634f","668":"d8951dbb","865":"6f6d3c35","885":"5cf63e85","949":"2c7980cd"}[chunkId] + ".chunk.js";
};